var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.vertical ? 'flex-direction: column' : ''),attrs:{"id":"joat_main"}},[_c('i',{staticClass:"fas fa-database",attrs:{"id":"joat_icon"}}),_c('span',{staticClass:"ff-kanit"},[_vm._v(_vm._s(_vm.app_name.toUpperCase()))])])}
var staticRenderFns = []

export { render, staticRenderFns }